// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JKpegL5OZGbGDmoFyBdc {\n  background-color: var(--mantine-color-gray-7);\n}\n", "",{"version":3,"sources":["webpack://./jsapp/js/theme/kobo/Pill.module.css"],"names":[],"mappings":"AAAA;EACE,6CAA6C;AAC/C","sourcesContent":[".root {\n  background-color: var(--mantine-color-gray-7);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "JKpegL5OZGbGDmoFyBdc"
};
export default ___CSS_LOADER_EXPORT___;
